// COLUMNS
import { Tooltip } from "antd";
import i18next from "i18next";

import {
    getIconByGlobalPlantStatus,
    getIconByPlantSecond_reading,
    getIconByPlantStatus,
    getIconComponentByCaller,
    getProductionColumnValueByCaller,
    isSolarPhotovoltaicByCaller,
    isSolarThermalByCaller,
    isThermalByCaller,
    isWaterByCaller
} from "utils/Types";

import {
    getTimeDateMonthText,
    getTimeDateText,
    getTimeDateTextFull,
    getTimeHourText
} from "utils/Time";

import {
    getEcoSavings,
    getEnergyFormat,
    getWaterFormat
} from "../../utils/Formats";

import { Trash } from "react-feather";
import React from "react";
import { HiExternalLink } from "react-icons/hi";
import _ from "lodash";
import {
    BsThermometerSnow,
    BsThermometerSun
} from "react-icons/bs";

import { RiContrastDrop2Fill } from "react-icons/ri";
import config from "/app/src/config.js";
import { AiOutlineNotification } from "react-icons/ai";


const isMobileOnly = config.mbl_version;


/*
 * ============================================================
 * PRODUCTION TABLE COLUMNS
 * ============================================================
 */

export function getColumnTableProduction(config, column) {

    return {

        /*
         * ====================================================
         * DATE FULL
         * ====================================================
         */
        datefull: {

            name: (() => {

                if (config.time === "time.hourly") {
                    return i18next.t("datetime");
                }

                if (config.time === "time.daily") {
                    return i18next.t("date");
                }

                if (config.time === "time.monthly") {
                    return i18next.t("month");
                }

                return "";
            })(),

            sortable: true,

            selector: row => {

                if (config.time === "time.hourly") {
                    return getTimeDateTextFull(
                        row.plant_date
                    );
                }

                if (config.time === "time.daily") {
                    return getTimeDateText(
                        row.plant_date
                    );
                }

                if (config.time === "time.monthly") {
                    return getTimeDateMonthText(
                        row.plant_date
                    );
                }

                return "";
            },

            width: (() => {

                if (config.time === "time.hourly") {
                    return "175px !important";
                }

                if (config.time === "time.monthly") {

                    if (isMobileOnly) {
                        return undefined;
                    }

                    return "90px !important";
                }

                return "125px !important";
            })(),

            sortField: "plant_date"
        },


        /*
         * ====================================================
         * DATE
         * ====================================================
         */
        date: {

            name: i18next.t("date"),

            sortable: true,

            selector: row => {
                return getTimeDateText(
                    row.plant_date
                );
            },

            width:
                config.time === "time.hourly"
                    ? "120px !important"
                    : "115px !important",

            sortField: "plant_date"
        },


        /*
         * ====================================================
         * TIME
         * ====================================================
         */
        time: {

            name: i18next.t("time.hour"),

            sortable: true,

            selector: row => {
                return getTimeHourText(
                    row.plant_date
                );
            },

            width: "90px !important",

            sortField: "plant_date",

            center: true
        },


        /*
         * ====================================================
         * STATUS
         * ====================================================
         */
        status: {

            name: (
                <div
                    style={{
                        position: "relative",
                        display: "inline-block"
                    }}
                >
                    <AiOutlineNotification
                        size={20}
                    />

                    <span
                        style={{
                            position: "absolute",
                            bottom: -1,
                            right: -10,
                            color: "grey",
                            borderRadius: "50%",
                            padding: "1px 4px",
                            fontSize: "10px",
                            lineHeight: "1",
                            fontWeight: "bold"
                        }}
                    >
                        1
                    </span>
                </div>
            ),

            selector: row =>
                getIconByPlantStatus(
                    {
                        ...config,
                        hideEventOk: true
                    },
                    row.plant_alert
                ),

            width: "55px !important",

            style: {
                paddingLeft: "0px !important",
                paddingRight: "0px !important"
            },

            sortField: "plant_alert",

            center: true
        },


        /*
         * ====================================================
         * CO2 SAVINGS
         * ====================================================
         */
        co2_savings:
            isMobileOnly &&
                (
                    isSolarThermalByCaller(config) ||
                    isSolarPhotovoltaicByCaller(config)
                )
                ? {
                    width: "0px !important",
                    minWidth: "0px !important",
                    maxWidth: "0px !important",

                    style: {
                        paddingLeft: "0px !important",
                        paddingRight: "0px !important"
                    }
                }
                : {

                    name:
                        i18next.t(
                            "plant.savings"
                        ),

                    right: true,

                    sortable: true,

                    width: undefined,

                    style: {

                        paddingLeft:
                            "2px !important",

                        paddingRight: (() => {

                            if (
                                config.time ===
                                "time.monthly"
                            ) {
                                return "20px !important";
                            }

                            return "2px !important";
                        })()
                    },

                    selector: row => {

                        return (
                            getProductionColumnValueByCaller(
                                config,
                                row.plant_co2_savings
                            ).toFixed(2) +
                            "KgCO₂"
                        );
                    },

                    sortField:
                        "plant_co2_savings"
                },


        /*
         * ====================================================
         * ECO SAVINGS
         * ====================================================
         */
        eco_savings:
            isMobileOnly &&
                (
                    isSolarThermalByCaller(config) ||
                    isSolarPhotovoltaicByCaller(config)
                )
                ? {

                    width:
                        "0px !important",

                    minWidth:
                        "0px !important",

                    maxWidth:
                        "0px !important",

                    style: {
                        paddingLeft:
                            "0px !important",

                        paddingRight:
                            "0px !important"
                    }
                }
                : {

                    name:
                        i18next.t(
                            "plant.savings"
                        ),

                    sortable: true,

                    right: true,

                    width: undefined,

                    style: {

                        paddingLeft: (() => {

                            if (
                                isMobileOnly &&
                                (
                                    isSolarThermalByCaller(config) ||
                                    isSolarPhotovoltaicByCaller(config)
                                )
                            ) {
                                return "5px !important";
                            }

                            return "2px !important";
                        })(),

                        paddingRight: (() => {

                            if (
                                config.time ===
                                "time.monthly" &&
                                isWaterByCaller(config)
                            ) {
                                return "20px !important";
                            }

                            return "2px !important";
                        })()
                    },

                    selector: row => {

                        if (
                            isMobileOnly &&
                            (
                                isSolarThermalByCaller(config) ||
                                isSolarPhotovoltaicByCaller(config)
                            )
                        ) {

                            return (
                                <>
                                    <div>
                                        {
                                            `${row.plant_price_savings.toFixed(2)}€`
                                        }
                                    </div>

                                    <div>
                                        {
                                            `${row.plant_co2_savings.toFixed(2)}KgCO₂`
                                        }
                                    </div>
                                </>
                            );
                        }

                        return (
                            row.plant_price_savings.toFixed(2) +
                            "€"
                        );
                    },

                    sortField:
                        "plant_price_savings"
                },


        /*
         * ====================================================
         * PRODUCTION
         * ====================================================
         */
        production: {

            name:
                i18next.t(
                    "value"
                ),

            sortable: true,

            width: undefined,

            style: {

                paddingLeft:
                    "2px !important",

                paddingRight: (() => {

                    if (
                        config.time ===
                        "time.monthly"
                    ) {
                        return "20px !important";
                    }

                    return "2px !important";
                })()
            },

            right:
                !isMobileOnly ||
                isWaterByCaller(config) ||
                isThermalByCaller(config),

            selector: row => {

                if (
                    isThermalByCaller(config)
                ) {
                    return `${row.plant_energy}ºC`;
                }

                if (
                    isWaterByCaller(config)
                ) {
                    return `${row.plant_energy}L`;
                }

                return (
                    getProductionColumnValueByCaller(
                        config,
                        row.plant_energy
                    ).toFixed(0) +
                    "kWh"
                );
            },

            sortField:
                "plant_energy"
        },


        /*
         * ====================================================
         * SECOND READING
         * ====================================================
         */
        second_reading: {

            name: (
                <div
                    style={{
                        position: "relative",
                        display: "inline-block"
                    }}
                >
                    <AiOutlineNotification
                        size={20}
                    />

                    <span
                        style={{
                            position: "absolute",
                            bottom: -1,
                            right: -10,
                            color: "grey",
                            borderRadius: "50%",
                            padding: "1px 4px",
                            fontSize: "10px",
                            lineHeight: "1",
                            fontWeight: "bold"
                        }}
                    >
                        2
                    </span>
                </div>
            ),

            sortable: true,

            selector: row => {

                if (
                    row.second_reading === undefined ||
                    row.second_reading === null ||
                    row.second_reading === "" ||
                    row.second_reading === 2
                ) {
                    return "-";
                }

                return getIconByPlantSecond_reading(
                    {
                        ...config,
                        hideEventOk: true
                    },
                    row.second_reading
                );
            },

            width:
                "55px",

            style: {
                paddingLeft: "0px",
                paddingRight: "0px",
                textAlign: "center"
            },

            sortField:
                "second_reading_value"
        }

    }[column];
}


/*
 * ============================================================
 * SEYE VERSION
 * ============================================================
 */

const getSeyeVersion = row => {

    const serialNumber =
        Number(
            row.set_serial_number
        );


    if (!serialNumber) {
        return "";
    }


    if (
        serialNumber <=
        2503110000
    ) {
        return "2.0";
    }


    return "";
};


/*
 * ============================================================
 * GLOBAL STATUS COLUMN
 * ============================================================
 */

export function getGlobalStatusColumn(config) {

    return {

        selector: row => {

            const seyeVersion =
                getSeyeVersion(row);


            return (

                <div
                    style={{
                        position:
                            "relative",

                        width:
                            "85px",

                        height:
                            "100%",

                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "flex-end",

                        overflow:
                            "visible"
                    }}
                >

                    {seyeVersion && (

                        <span
                            style={{
                                position:
                                    "absolute",

                                right:
                                    "48px",

                                top:
                                    "50%",

                                transform:
                                    "translateY(-50%)",

                                fontSize:
                                    "15px",

                                fontWeight:
                                    "700",

                                lineHeight:
                                    "1",

                                whiteSpace:
                                    "nowrap",

                                pointerEvents:
                                    "none",

                                color:
                                    "#5f5f5f"
                            }}
                        >

                            {seyeVersion}

                        </span>
                    )}


                    <div
                        style={{
                            width:
                                "55px",

                            display:
                                "flex",

                            justifyContent:
                                "center",

                            alignItems:
                                "center"
                        }}
                    >

                        {
                            getIconByGlobalPlantStatus(
                                config,
                                row
                            )
                        }

                    </div>

                </div>
            );
        },

        sortable:
            true,

        width:
            "85px",

        sortField:
            "plant_status_id",

        center:
            true,

        style: {

            paddingLeft:
                "0px !important",

            paddingRight:
                "0px !important",

            overflow:
                "visible !important"
        }
    };
}


/*
 * ============================================================
 * DELETE COLUMN
 * ============================================================
 *
 * MODO ELIMINAR:
 *
 *       2.0     ESTADO     🗑
 *
 * El modo eliminar mantiene visible:
 *
 * - Versión SeYe
 * - Estado global
 * - Botón eliminar
 *
 * ============================================================
 */

export function getDeleteColumn(
    configuration,
    actions
) {

    return {

        selector: row => {

            const seyeVersion =
                getSeyeVersion(row);


            return (

                <div
                    style={{
                        width:
                            "125px",

                        height:
                            "100%",

                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "flex-end",

                        overflow:
                            "visible"
                    }}
                >

                    {/*
                     * VERSION SEYE
                     */}
                    <div
                        style={{
                            width:
                                "35px",

                            display:
                                "flex",

                            justifyContent:
                                "center",

                            alignItems:
                                "center",

                            fontSize:
                                "15px",

                            fontWeight:
                                "700",

                            lineHeight:
                                "1",

                            whiteSpace:
                                "nowrap",

                            color:
                                "#5f5f5f"
                        }}
                    >

                        {
                            seyeVersion
                                ? seyeVersion
                                : ""
                        }

                    </div>


                    {/*
                     * ESTADO GLOBAL
                     */}
                    <div
                        style={{
                            width:
                                "50px",

                            display:
                                "flex",

                            justifyContent:
                                "center",

                            alignItems:
                                "center"
                        }}
                    >

                        {
                            getIconByGlobalPlantStatus(
                                configuration,
                                row
                            )
                        }

                    </div>


                    {/*
                     * ELIMINAR
                     */}
                    <div
                        style={{
                            width:
                                "40px",

                            display:
                                "flex",

                            justifyContent:
                                "center",

                            alignItems:
                                "center"
                        }}
                    >

                        <Trash
                            size={20}
                            style={{
                                cursor:
                                    "pointer",

                                color:
                                    "#ea5455"
                            }}
                            onClick={event => {

                                event.stopPropagation();

                                if (
                                    actions &&
                                    typeof actions.trashHandler ===
                                    "function"
                                ) {

                                    actions.trashHandler(
                                        row
                                    );
                                }
                            }}
                        />

                    </div>

                </div>
            );
        },

        sortable:
            false,

        width:
            "125px",

        center:
            true,

        style: {

            paddingLeft:
                "0px !important",

            paddingRight:
                "0px !important",

            overflow:
                "visible !important"
        }
    };
}


/*
 * ============================================================
 * DAILY STATUS
 * ============================================================
 */

export function getDailyStatusColumn(config) {

    return {

        name: (
            <Tooltip
                placement="topLeft"
                title={
                    i18next.t(
                        "plant.daily_status_extended"
                    )
                }
                overlayStyle={{
                    fontSize: "13px"
                }}
            >
                {
                    i18next.t(
                        "plant.daily_status"
                    )
                }
            </Tooltip>
        ),

        selector: row =>
            getIconByPlantStatus(
                config,
                row.plant_daily_alert_id
            ),

        sortable:
            true,

        width:
            "80px",

        sortField:
            "plant_status_id",

        center:
            true
    };
}


/*
 * ============================================================
 * HOURLY STATUS
 * ============================================================
 */

export function getHourlyStatusColumn(config) {

    return {

        name: (
            <Tooltip
                placement="topLeft"
                title={
                    i18next.t(
                        "plant.hourly_status_extended"
                    )
                }
                overlayStyle={{
                    fontSize: "13px"
                }}
            >

                {
                    i18next.t(
                        "plant.hourly_status"
                    )
                }

            </Tooltip>
        ),

        selector: row =>
            getIconByPlantStatus(
                config,
                row.plant_hourly_alert_id
            ),

        sortable:
            true,

        width:
            "80px",

        sortField:
            "plant_hourly_alert_id",

        center:
            true
    };
}


/*
 * ============================================================
 * SHOW COLUMN
 * ============================================================
 */

export function getShowColumn(
    configuration,
    actions
) {

    let baseStyle = {

        paddingLeft:
            "5px !important",

        paddingRight:
            "0px !important"
    };


    if (isMobileOnly) {

        baseStyle = {

            ...baseStyle,

            alignItems:
                "normal !important"
        };
    }


    return {

        sortable:
            false,

        style:
            baseStyle,

        selector: row => (

            <HiExternalLink
                style={{
                    color:
                        "#5f5f5f",

                    cursor:
                        "pointer"
                }}
                size="1.5em"
                onClick={() =>
                    actions.showHandler(row)
                }
            />
        ),

        width:
            "25px !important",

        center:
            true
    };
}


/*
 * ============================================================
 * NAME COLUMN
 * ============================================================
 */

export function getNameColumn(
    configuration,
    actions
) {

    let baseStyle = {

        paddingLeft:
            "10px !important",

        minWidth:
            "200px !important"
    };


    if (isMobileOnly) {

        baseStyle = {

            ...baseStyle,

            paddingLeft:
                "10px !important",

            wordBreak:
                "break-all !important",

            minWidth:
                "unset !important"
        };
    }


    return {

        name:
            i18next.t(
                "name"
            ),

        style:
            baseStyle,

        sortable:
            true,

        grow:
            1,

        selector: row => {

            if (isMobileOnly) {

                return (

                    <div
                        style={{
                            pointerEvents:
                                "none"
                        }}
                    >

                        <div
                            style={{
                                pointerEvents:
                                    "none"
                            }}
                        >

                            {row.plant_name}

                        </div>


                        <div
                            style={{
                                pointerEvents:
                                    "none",

                                fontSize:
                                    "12px",

                                color:
                                    "dimgrey"
                            }}
                        >

                            {row.plant_town_name}

                        </div>


                        <div
                            style={{
                                pointerEvents:
                                    "none",

                                fontSize:
                                    "13px",

                                marginTop:
                                    "3px",

                                display:
                                    "flex",

                                alignItems:
                                    "center"
                            }}
                        >

                            {
                                (
                                    isSolarPhotovoltaicByCaller(
                                        configuration
                                    ) ||
                                    isSolarThermalByCaller(
                                        configuration
                                    ) ||
                                    isWaterByCaller(
                                        configuration
                                    )
                                ) && (

                                    <>

                                        <div
                                            style={{
                                                pointerEvents:
                                                    "none",

                                                width:
                                                    "60px",

                                                display:
                                                    "flex",

                                                alignItems:
                                                    "baseline",

                                                whiteSpace:
                                                    "nowrap",

                                                lineHeight:
                                                    "1"
                                            }}
                                        >

                                            <span>
    <span
        style={{
            display: "inline-block",
            borderTop: "1px solid currentColor",
            lineHeight: "0.9",
            paddingTop: "1px"
        }}
    >
        {"\u03F0"}
    </span>
    :&nbsp;
    {
        `${_.get(
            row,
            "last_30_plant_performance",
            0
        ).toFixed(0)}%`
    }
</span>

                                        </div>


                                        <span>
                                            &nbsp;&nbsp;|&nbsp;&nbsp;
                                        </span>

                                    </>
                                )
                            }


                            {
                                isThermalByCaller(
                                    configuration
                                ) && (

                                    <>

                                        <div
                                            style={{
                                                pointerEvents:
                                                    "none",

                                                width:
                                                    "60px",

                                                display:
                                                    "flex",

                                                alignItems:
                                                    "center"
                                            }}
                                        >

                                            <div
                                                style={{
                                                    pointerEvents:
                                                        "none"
                                                }}
                                            >

                                                <BsThermometerSnow
                                                    size="15px"
                                                />

                                                &nbsp;

                                            </div>


                                            <div
                                                style={{
                                                    pointerEvents:
                                                        "none"
                                                }}
                                            >

                                                {
                                                    `${row.min_value}ºC`
                                                }

                                            </div>

                                        </div>


                                        <span>
                                            &nbsp;&nbsp;|&nbsp;&nbsp;
                                        </span>

                                    </>
                                )
                            }


                            <div
                                style={{
                                    pointerEvents:
                                        "none",

                                    display:
                                        "flex",

                                    alignItems:
                                        "center"
                                }}
                            >

                                {
                                    getIconComponentByCaller(
                                        configuration,
                                        {
                                            size: 15,

                                            style: {
                                                marginRight:
                                                    "5px"
                                            }
                                        }
                                    )
                                }


                                {(() => {

                                    if (
                                        isSolarThermalByCaller(
                                            configuration
                                        )
                                    ) {

                                        return getEnergyFormat(
                                            row.last_production_lecture *
                                            1000
                                        );
                                    }


                                    if (
                                        isSolarPhotovoltaicByCaller(
                                            configuration
                                        )
                                    ) {

                                        return getEnergyFormat(
                                            row.last_production_lecture
                                        );
                                    }


                                    if (
                                        isWaterByCaller(
                                            configuration
                                        )
                                    ) {

                                        return (
                                            getWaterFormat(
                                                row.last_production_lecture
                                            ) +
                                            "/h"
                                        );
                                    }


                                    if (
                                        isThermalByCaller(
                                            configuration
                                        )
                                    ) {

                                        if (
                                            !row.last_production_lecture
                                        ) {
                                            return "??ºC";
                                        }

                                        return (
                                            `${row.last_production_lecture}ºC`
                                        );
                                    }


                                    return "";
                                })()}

                            </div>


                            {
    isThermalByCaller(configuration) && (

                                    <>

                                        <span>
                                            &nbsp;&nbsp;|&nbsp;&nbsp;
                                        </span>


                                        <div
                                            style={{
                                                pointerEvents:
                                                    "none",

                                                display:
                                                    "flex",

                                                alignItems:
                                                    "center"
                                            }}
                                        >

                                            {(() => {

                                                if (
                                                    isWaterByCaller(
                                                        configuration
                                                    )
                                                ) {

                                                    return (
                                                        <>
                                                            <RiContrastDrop2Fill
                                                                size="15px"
                                                            />

                                                            &nbsp;

                                                            {
                                                                `${getWaterFormat(
                                                                    row.max_value
                                                                )}/h`
                                                            }
                                                        </>
                                                    );
                                                }


                                                if (
                                                    isThermalByCaller(
                                                        configuration
                                                    )
                                                ) {

                                                    return (
                                                        <>
                                                            <BsThermometerSun
                                                                size="15px"
                                                            />

                                                            &nbsp;

                                                            {
                                                                `${row.max_value}ºC`
                                                            }
                                                        </>
                                                    );
                                                }


                                                return null;
                                            })()}

                                        </div>

                                    </>
                                )
                            }

                        </div>

                    </div>
                );
            }


            return row.plant_name;
        },

        sortField:
            "plant_name",

        wrap:
            true
    };
}


/*
 * ============================================================
 * LOCATION
 * ============================================================
 */

export function getLocationColumn() {

    if (isMobileOnly) {

        return {

            width:
                "0px !important",

            minWidth:
                "0px !important",

            maxWidth:
                "0px !important",

            style: {

                paddingLeft:
                    "0px !important",

                paddingRight:
                    "0px !important"
            }
        };
    }


    return {

        name:
            i18next.t(
                "location"
            ),

        sortable:
            true,

        selector: row =>
            row.plant_town_name,

        sortField:
            "plant_name",

        style: {
            minWidth:
                "250px !important"
        }
    };
}


/*
 * ============================================================
 * NAME FULL
 * ============================================================
 */

export function getNameFullColumn(
    configuration,
    actions
) {

    return {

        name:
            i18next.t(
                "name"
            ),

        sortable:
            true,

        selector: row =>
            row.plant_name_full,

        sortField:
            "plant_name_full",

        minWidth:
            "500px !important"
    };
}


/*
 * ============================================================
 * ADDRESS
 * ============================================================
 */

export function getAddressColumn() {

    return {

        name:
            i18next.t(
                "address"
            ),

        sortable:
            true,

        selector: row =>
            row.plant_address_all,

        sortField:
            "plant_address_all"
    };
}


/*
 * ============================================================
 * PRODUCTION COLUMN
 * ============================================================
 */

export function getProductionColumn(
    configuration
) {

    if (isMobileOnly) {

        return {

            width:
                "0px !important",

            minWidth:
                "0px !important",

            maxWidth:
                "0px !important",

            style: {

                paddingLeft:
                    "0px !important",

                paddingRight:
                    "0px !important"
            }
        };
    }


    return {

        name: (() => {

            if (
                isWaterByCaller(
                    configuration
                )
            ) {

                return (
                    <Tooltip
                        placement="topLeft"
                        title={
                            i18next.t(
                                "last_reading"
                            )
                        }
                        overlayStyle={{
                            fontSize:
                                "13px"
                        }}
                    >

                        {
                            `${i18next.t(
                                "last_female"
                            )} *`
                        }

                    </Tooltip>
                );
            }


            if (
                isSolarPhotovoltaicByCaller(
                    configuration
                )
            ) {

                return (
                    <Tooltip
                        placement="topLeft"
                        title={
                            i18next.t(
                                "last_reading"
                            )
                        }
                        overlayStyle={{
                            fontSize:
                                "13px"
                        }}
                    >

                        {
                            `${i18next.t(
                                "plant.production"
                            )} *`
                        }

                    </Tooltip>
                );
            }


            if (
                isSolarThermalByCaller(
                    configuration
                )
            ) {

                return (
                    <Tooltip
                        placement="topLeft"
                        title={
                            i18next.t(
                                "last_reading"
                            )
                        }
                        overlayStyle={{
                            fontSize:
                                "13px"
                        }}
                    >

                        {
                            `${i18next.t(
                                "plant.production"
                            )} *`
                        }

                    </Tooltip>
                );
            }


            if (
                isThermalByCaller(
                    configuration
                )
            ) {

                return (
                    <Tooltip
                        placement="topLeft"
                        title={
                            i18next.t(
                                "last_reading"
                            )
                        }
                        overlayStyle={{
                            fontSize:
                                "13px"
                        }}
                    >

                        {
                            `${i18next.t(
                                "last_female"
                            )} *`
                        }

                    </Tooltip>
                );
            }


            return "";
        })(),

        sortable:
            true,

        selector: row => {

            if (
                isSolarThermalByCaller(
                    configuration
                )
            ) {

                return getEnergyFormat(
                    row.last_production_lecture *
                    1000
                );
            }


            if (
                isSolarPhotovoltaicByCaller(
                    configuration
                )
            ) {

                return getEnergyFormat(
                    row.last_production_lecture
                );
            }


            if (
                isWaterByCaller(
                    configuration
                )
            ) {

                return (
                    getWaterFormat(
                        row.last_production_lecture
                    ) +
                    "/h"
                );
            }


            if (
                isThermalByCaller(
                    configuration
                )
            ) {

                if (
                    !row.last_production_lecture
                ) {
                    return "??";
                }

                return (
                    `${row.last_production_lecture}ºC`
                );
            }


            return "";
        },

        width: (() => {

            if (
                isThermalByCaller(
                    configuration
                )
            ) {

                return "110px !important";
            }


            return "170px !important";
        })(),

        right:
            true,

        sortField:
            "last_production_lecture"
    };
}


/*
 * ============================================================
 * MINIMUM
 * ============================================================
 */

export function getMinColumn(
    configuration
) {

    if (isMobileOnly) {

        return {

            width:
                "0px !important",

            minWidth:
                "0px !important",

            maxWidth:
                "0px !important",

            style: {

                paddingLeft:
                    "0px !important",

                paddingRight:
                    "0px !important"
            }
        };
    }


    return {

        name: (() => {

            if (
                isWaterByCaller(
                    configuration
                )
            ) {

                return i18next.t(
                    "minimum"
                );
            }


            if (
                isThermalByCaller(
                    configuration
                )
            ) {

                return i18next.t(
                    "minimum_female"
                );
            }


            return "";
        })(),

        sortable:
            true,

        selector: row =>
            `${row.min_value}ºC`,

        right:
            true,

        width:
            "110px !important",

        sortField:
            "min_value"
    };
}


/*
 * ============================================================
 * MAXIMUM
 * ============================================================
 */

export function getMaxColumn(
    configuration
) {

    if (isMobileOnly) {

        return {

            width:
                "0px !important",

            minWidth:
                "0px !important",

            maxWidth:
                "0px !important",

            style: {

                paddingLeft:
                    "0px !important",

                paddingRight:
                    "0px !important"
            }
        };
    }


    return {

        name: (() => {

            if (
                isWaterByCaller(
                    configuration
                )
            ) {

                return i18next.t(
                    "maximum"
                );
            }


            if (
                isThermalByCaller(
                    configuration
                )
            ) {

                return i18next.t(
                    "maximum_female"
                );
            }


            return "";
        })(),

        sortable:
            true,

        selector: row => {

            if (
                isWaterByCaller(
                    configuration
                )
            ) {

                return (
                    `${getWaterFormat(
                        row.max_value
                    )}/h`
                );
            }


            if (
                isThermalByCaller(
                    configuration
                )
            ) {

                return (
                    `${row.max_value}ºC`
                );
            }


            return "";
        },

        right:
            true,

        width:
            "110px !important",

        sortField:
            "max_value"
    };
}


/*
 * ============================================================
 * SINCE
 * ============================================================
 */

export function getSinceColumn(
    configuration
) {

    return {

        name:
            i18next.t(
                "synced_since"
            ),

        sortable:
            true,

        selector: row => {

            if (!row.sync_date) {
                return "-";
            }

            return getTimeDateText(
                row.sync_date
            );
        },

        width:
            "120px !important",

        sortField:
            "sync_date"
    };
}


/*
 * ============================================================
 * NORMAL ACTIONS
 * ============================================================
 */

export function getActionsColumn(
    configuration,
    actions
) {

    let baseStyle = {

        paddingLeft:
            "10px !important",

        paddingRight:
            "10px !important"
    };


    if (isMobileOnly) {

        baseStyle = {

            ...baseStyle,

            paddingLeft:
                "0px !important"
        };
    }


    if (isMobileOnly) {

        return {

            width:
                "0px !important",

            minWidth:
                "0px !important",

            maxWidth:
                "0px !important",

            style: {

                paddingLeft:
                    "0px !important",

                paddingRight:
                    "0px !important"
            }
        };
    }


    return {

        sortable:
            false,

        style:
            baseStyle,

        selector: row => (

            <Trash
                style={{
                    color:
                        "#5f5f5f",

                    cursor:
                        "pointer"
                }}
                size="1.5em"
                onClick={() =>
                    actions.trashHandler(row)
                }
            />
        ),

        width:
            "40px !important",

        center:
            true
    };
}


/*
 * ============================================================
 * ECO
 * ============================================================
 */

export function getEcoColumn(
    configuration
) {

    return {

        name: (() => {

            if (
                isWaterByCaller(
                    configuration
                )
            ) {

                return (
                    <Tooltip
                        placement="topLeft"
                        title={
                            i18next.t(
                                "last_reading"
                            )
                        }
                        overlayStyle={{
                            fontSize:
                                "13px"
                        }}
                    >

                        {
                            `${i18next.t(
                                "price"
                            )} *`
                        }

                    </Tooltip>
                );
            }


            return (
                <Tooltip
                    placement="topLeft"
                    title={
                        i18next.t(
                            "last_reading"
                        )
                    }
                    overlayStyle={{
                        fontSize:
                            "13px"
                    }}
                >

                    {
                        `${i18next.t(
                            "plant.savings"
                        )} *`
                    }

                </Tooltip>
            );
        })(),

        sortable:
            true,

        selector: row =>
            getEcoSavings(
                row.last_eco_lecture
            ),

        right:
            true,

        width:
            "110px !important",

        sortField:
            "last_eco_lecture"
    };
}


/*
 * ============================================================
 * PERFORMANCE
 * ============================================================
 */

export function getPerformanceColumn(
    configuration
) {

    if (isMobileOnly) {

        return {

            width:
                "0px !important",

            minWidth:
                "0px !important",

            maxWidth:
                "0px !important",

            style: {

                paddingLeft:
                    "0px !important",

                paddingRight:
                    "0px !important"
            }
        };
    }


    return {

        name: (
            <span
                style={{
                    textTransform:
                        "lowercase",

                    fontSize:
                        "16px"
                }}
            >
                {"\u03BA\u0304"}:
            </span>
        ),

        sortable:
            true,

        selector: row => {

            if (
                !row.last_30_plant_performance
            ) {
                return "0%";
            }


            return (
                `${row.last_30_plant_performance.toFixed(0)}%`
            );
        },

        right:
            true,

        width:
            "80px !important",

        sortField:
            "last_30_plant_performance",

        style: {

            paddingLeft:
                "10px !important",

            paddingRight:
                "10px !important"
        }
    };
}